import { checkStatus } from '../../utilities/fetch';
import { companiesSearchPath } from '../../utilities/api_relative_paths';
import { createQueryString } from '../../utilities/utilities';

/**
 * Function to fetch filtered organizations
 *
 * @param {object} queryParams - query params ready to be sent to the BE
 * @returns {Promise} Promise that can be consumed
 */
const getOrganizations = (queryParams) => {
  return fetch(companiesSearchPath + createQueryString(queryParams))
    .then(checkStatus)
    .then((response) => response.json())
    .catch((error) => Promise.reject(error));
};

export { getOrganizations };
